<script lang="ts">
</script>

<svg
  viewBox="0 0 26 33"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="size-10"
>
  <path
    d="M0 17.866L0.533308 6.27059L7.70386 0L21.1853 1.84437L25.4879 11.3926L24.3824 19.6284L18.7687 22.1283L18.6048 31.0196L6.5164 32.8237L6.06503 23.2755L0 17.866Z"
    fill="white"
  />
  <path
    d="M8.06781 27.7218H16.4703V21.529L21.3354 18.4333L22.6631 12.2419L18.6827 4.27971L8.06781 2.51172L2.31803 7.37681L1.875 17.107L7.62476 22.8568L8.06781 27.7218Z"
    fill="#0D0D0D"
  />
  <path
    d="M8.07031 28.6055H16.4728V29.9318L8.07031 30.3735V28.6055Z"
    fill="#0D0D0D"
  />
  <path
    d="M11.6522 27.7722V24.8653L10.5703 20.978L12.9369 14.7907L11.9564 12.4922H12.598L14.0521 14.9601L11.6856 21.0794L13.173 25.2375L13.1397 27.9416L11.6522 27.7722Z"
    fill="white"
  />
  <path
    d="M8.07031 13.1694L8.67862 13L12.4979 17.497L11.7882 18.9845L8.07031 13.1694Z"
    fill="white"
  />
</svg>
